import { Box, createSlotRecipeContext, HTMLChakraProps, Portal, RecipeVariantProps } from '@chakra-ui/react';
import { RawButtonBarRoot } from '@components/ui/buttonBar/Root';
import { buttonBarSlotRecipe } from '@theme/component/buttonBar.recipe';
import { forwardRef, PropsWithChildren, RefObject } from 'react';

const { withProvider, withContext } = createSlotRecipeContext({ recipe: buttonBarSlotRecipe });

type ButtonVariantProps = HTMLChakraProps<'button'> & RecipeVariantProps<typeof buttonBarSlotRecipe>;

type ClickHandlers =
  | { onClick: () => void; onMouseDown?: never; onMouseUp?: never }
  | { onClick?: never; onMouseDown: () => void; onMouseUp: () => void };
export interface ButtonBarRootBaseProps extends HTMLChakraProps<'button'>, ButtonVariantProps {
  isHidden?: boolean;
  notch?: boolean;
  notchPlacement?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
  hideTooltip?: boolean;
  tooltipPlacement?: 'top' | 'right' | 'left';
  colorPalette?: 'neutralBlue' | 'blue' | 'orange' | 'red';
  shouldFlicker?: boolean;
}
export type ButtonBarRootProps = ButtonBarRootBaseProps & ClickHandlers;

export const ButtonBarRoot = withProvider<HTMLButtonElement, ButtonBarRootProps>(RawButtonBarRoot, 'root', {
  forwardAsChild: true,
});

type ButtonBarControlProps = HTMLChakraProps<'div'>;
export const ButtonBarControl = withContext<HTMLDivElement, ButtonBarControlProps>('div', 'control');

export const ButtonPortal = forwardRef<HTMLDivElement, PropsWithChildren<ButtonBarPortalProps>>(({ children }, ref) => {
  return (
    <Portal container={ref as RefObject<HTMLDivElement>}>
      <Box position="relative">{children}</Box>
    </Portal>
  );
});

type ButtonBarPortalProps = HTMLChakraProps<'div'>;
export const ButtonBarPortal = withContext<HTMLSpanElement, ButtonBarPortalProps>(ButtonPortal, 'portal');
